module.exports = __webpack_public_path__ + "img/unipay.8b82faed.png";